import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/volume-x.vue
var o = {
	name: "DtIconVolumeX",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--volume-x"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Volume X",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [...t[0] || (t[0] = [r("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M5.717 2.05A.5.5 0 0 1 6 2.5v7a.5.5 0 0 1-.812.39L2.825 8H1a.5.5 0 0 1-.5-.5v-3A.5.5 0 0 1 1 4h1.825l2.363-1.89a.5.5 0 0 1 .529-.06ZM5 3.54 3.312 4.89A.5.5 0 0 1 3 5H1.5v2H3a.5.5 0 0 1 .312.11L5 8.46V3.54Zm2.646.606a.5.5 0 0 1 .708 0L9.5 5.293l1.146-1.147a.5.5 0 0 1 .708.708L10.207 6l1.147 1.146a.5.5 0 0 1-.708.708L9.5 6.707 8.354 7.854a.5.5 0 1 1-.708-.708L8.793 6 7.646 4.854a.5.5 0 0 1 0-.708Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=volume-x.js.map